var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-layout',{attrs:{"data-testid":"report-manager"}},[_c('JtDocsViewer',{ref:"reportModal",attrs:{"src":_vm.fileSrc,"title":_vm.reportTitle,"pdf":_vm.reportFormat.pdf,"xls":_vm.reportFormat.xls},on:{"hide":_vm.emitCloseToBus}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }